

















































































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

@Component
export default class RegisterInput extends Vue {
    @Prop() public name!: string;
    @Prop() public kana!: string;
    @Prop() public companyName!: string;
    @Prop() public address!: string;
    @Prop() public phoneNumber!: string;
    public confirm = false;

    @Emit()
    public inputNameEmit(inputName: string) {
        //console.log(inputName);
    }

    @Emit()
    public inputKanaEmit(inputKana: string) {
        //console.log(inputKana);
    }

    @Emit()
    public inputCompanyNameEmit(inputCompanyName: string) {
        //console.log(inputCompanyName);
    }

    @Emit()
    public inputAddressEmit(inputAddress: string) {
        //console.log(inputAddress);
    }

    @Emit()
    public inputPhoneNumberEmit(inputPhoneNumber: string) {
        //console.log(inputPhoneNumber);
    }

    @Emit()
    public inputConfirmEmit(inputConfirm: boolean) {
        inputConfirm;
    }

    private get inputName(): string {
        return this.name;
    }

    private set inputName(name: string) {
        this.inputNameEmit(name);
    }

    private get inputKana(): string {
        return this.kana;
    }

    private set inputKana(kana: string) {
        this.inputKanaEmit(kana);
    }

    private get inputCompanyName(): string {
        return this.companyName;
    }

    private set inputCompanyName(companyName: string) {
        this.inputCompanyNameEmit(companyName);
    }

    private get inputAddress(): string {
        return this.address;
    }

    private set inputAddress(address: string) {
        this.inputAddressEmit(address);
    }

    private get inputPhoneNumber(): string {
        return this.phoneNumber;
    }

    private set inputPhoneNumber(phoneNumber: string) {
        this.inputPhoneNumberEmit(phoneNumber);
    }
}
